<div class="border-bottom pb-4 pt-4 mb-2">
  <div class="d-flex align-items-center mb-2">
    <tr-icon [icon]="icon.settings2" [size]="size.extraLarge" classes="mr-3"></tr-icon>
    <h2 *ngIf="location" class="m-0">API</h2>
  </div>

  <form [formGroup]="form" (ngSubmit)="save()" class="pl-5">
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="public-api-enabled" class="col-form-label">Enable this to allow walk-ins and {{location.displayOptions.labels.reservation_plural}} to be created via an API</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              id="public-api-enabled"
              name="enabled"
              formControlName="enabled"
            >Enable
          </label>
        </div>
      </div>
    </div>

    <div class="row form-group" *ngIf="form.get('apiKey')">
      <div class="col-lg-5 col-xl-4">
        <label for="api-key" class="col-form-label lead">Api key</label>
      </div>
      <div class="col-lg-7 col-xl-8">
        <div class="form-group row">
          <div class="col-12 col-xl-8 col-xxl-6">
            <input
              type="text"
              id="api-key"
              name="apiKey"
              class="form-control"
              formControlName="apiKey"
            />
          </div>
        </div>
      </div>
    </div>

    <button
      class="btn btn-success"
      [disabled]="form.invalid || sending || form.pristine"
      style="width: 89px;"
    >Save</button>
  </form>
</div>
